import { render, staticRenderFns } from "./PopupBox.vue?vue&type=template&id=637546ea&scoped=true&"
import script from "./PopupBox.vue?vue&type=script&lang=js&"
export * from "./PopupBox.vue?vue&type=script&lang=js&"
import style0 from "./PopupBox.vue?vue&type=style&index=0&id=637546ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "637546ea",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('637546ea')) {
      api.createRecord('637546ea', component.options)
    } else {
      api.reload('637546ea', component.options)
    }
    module.hot.accept("./PopupBox.vue?vue&type=template&id=637546ea&scoped=true&", function () {
      api.rerender('637546ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2ndmIV0VK7z4x/JS/comp/PopupBox.vue"
export default component.exports